<template>
  <div class="mt-4">
    <div class="d-flex">
      <search-field class="white" v-model="search" />
      <v-spacer></v-spacer>
      <create v-if="isAdmin || isDataEntry || isDataEntryAndDispatcher"></create>
    </div>
    <v-card :elevation="$root.ele" class="mt-5">
      <v-data-table
        :items-per-page="-1"
        :headers="headers"
        :items="list"
        :search="search"
        class="templates-table"
      >
        <template v-slot:item.is_calculated="{ item }">
          {{ item.is_calculated ? "Yes" : "No" }}
        </template>
        <template v-slot:item.field_type="{ item }">
          <div class="text-capitalize">
            {{ item.field_type }}
          </div>
        </template>
        <template v-slot:item.is_used="{ item }">
          {{ item.is_used ? "Yes" : "No" }}
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex">
            <create :item="item"></create>
            <remove-icon-button
              v-if="!item.is_fixed && isAdmin"
              @click="remove(item)"
            ></remove-icon-button>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { globalFields } from "../../assets/js/firebase";
// import { parseFormulaHTML } from "../../assets/js/import.template.js";
import RemoveIconButton from "../buttons/RemoveIconButton.vue";
import SearchField from "../ui/form/SearchField.vue";
import Create from "./global/Create.vue";
export default {
  components: { Create, RemoveIconButton, SearchField },
  data() {
    return {
      search: "",
    };
  },
  computed: {
    list() {
      return this.$store.getters.globalFields;
    },
    headers() {
      let headers = {
        name: "Field Name",
        field_type: "Field Type",
        is_calculated: "Calculated Field?",
        is_used: "Used in Calculation?",
        action: "Action",
      };
      let list = [];
      Object.keys(headers).forEach((value) => {
        let doc = {
          value,
          divider: true,
          class: "text-capitalize",
          text: headers[value].toUpperCase(),
        };
        if (value === "action") {
          doc.divider = false;
          doc.width = "120px";
        }
        list.push(doc);
      });
      return list;
    },
  },
  methods: {
    async remove({ id }) {
      const vm = this;
      vm.$confirm.show({
        message: "Are you sure you want to remove this Global field?",
        onConfirm: async () => {
          try {
            vm.$root.loader = true;
            await globalFields.doc(id).update({
              removed: true,
            });
            // await globalFields.doc(id).delete();
            vm.$root.loader = false;
          } catch (error) {
            vm.$root.alert(error.message);
            vm.$root.loader = false;
          }
        },
      });
    },
  },
  mounted() {
    // parseFormulaHTML("Od36bsTxsOGzdPlVFJfu", this);
  },
};
</script>

<style></style>
